import { render, staticRenderFns } from "./MerchantVisitation.vue?vue&type=template&id=58adf650&scoped=true&"
import script from "./MerchantVisitation.vue?vue&type=script&lang=js&"
export * from "./MerchantVisitation.vue?vue&type=script&lang=js&"
import style0 from "./MerchantVisitation.vue?vue&type=style&index=0&id=58adf650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58adf650",
  null
  
)

export default component.exports